<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div class="inquery-item-cont mt-5" v-if="item">
    <div class="inquery-item-id">
      <a @click="onDetails">
        <div class="inqiery-link-info">
          <label class="inquery-item-info-t" for="disabledTextInput">
            {{ tab.type === 'Contract' ? 'رقم وثيقة العقد' : 'رقم الطلب' }}</label>
          <span class="inquery-item-info-v">
            {{ tab.type === 'Contract' ? item.contractCode : item.requestCode }}
          </span>
        </div>
        <span class="servicesButton__seeMore"></span>
      </a>
    </div>
    <div class="inquery-item-info-cont text-right">
      <div class="fw-1 inquery-item-info">
        <div class="inquery-item-info-t">اسم العقد</div>
        <div class="inquery-item-info-v">{{ item.contractName }}</div>
      </div>
      <div class="fw-1 inquery-item-info" v-if="tab.type === 'Request'">
        <div class="inquery-item-info-t">تاريخ إنشاء الطلب</div>
        <div class="inquery-item-info-v">{{ item.createdDate | formatGregToHijri }}</div>
      </div>
      <div class="fw-1 inquery-item-info" v-if="tab.type === 'Contract'">
        <div class="inquery-item-info-t">تاريخ بداية العقد</div>
        <div class="inquery-item-info-v" v-if="item.startDate">{{ item.startDate.date | formatGregToHijri }}</div>
      </div>
      <div class="fw-1 inquery-item-info" v-if="tab.type === 'Contract'">
          <div class="inquery-item-info-t">تاريخ نهاية العقد</div>
          {{item.endDate.greg}}
          <div class="inquery-item-info-v" v-if="item.endDate.date">{{ item.endDate.date | formatGregToHijri }}</div>
          <p class="contract-end-date"  v-else>  --- </p>
      </div>
      <div class="fw-1 inquery-item-info">
        <div class="inquery-item-info-t">نوع الطرف</div>
        <div class="inquery-item-info-v">{{ item.partnerTypeName }}</div>
      </div>
      <div class="fw-1 inquery-item-info" v-if="tab.type === 'Request'">
        <div class="inquery-item-info-t">نوع الطلب</div>
        <div class="inquery-item-info-v">{{ item.requestTypeName }}</div>
      </div>
      <div class="fw-1 inquery-item-info">
        <div class="inquery-item-info-t">{{ tab.type === 'Contract' ? 'حالة العقد' : 'حالة الطلب' }}</div>
        <div class="inquery-item-info-v" :class="item.statusClass"> {{ item.statusName }}
        </div>
      </div>
      <div v-if="tab.type === 'Contract' && item.isNajizRequest" class="fw-1 inquery-item-info">
        <div class="inquery-item-info-t"></div>
        <div class="inquery-item-info-v">
          <button class="btn btn-sm btn-outline-primary btn-block" @click="onDownload(item.contractCode)">تحميل وثيقة العقد</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

import { Tab } from './tab.model';
import { ContractModel } from '@/models/contractDetailsModel';

@Component
export default class ItemComponent extends Vue {
  /** The contract object. */
  @Prop({ required: true }) item!: ContractModel;

  /** The current selected tab. */
  @Prop({ default: { name: 'ApprovedContracts', type: 'Contract' }, required: true }) tab!: Tab;

  /**
   * Emitted when the details button is clicked.
   */
  onDetails(): void {
    const code = this.tab.type === 'Contract' ? this.item.contractCode : this.item.requestCode;
    this.$emit('click:details', code);
  }

  /**
   * Emitted when the download button is clicked.
   * @param code The item's code.
   */
  onDownload(code: number | null): void {
    this.$emit('click:download', code);
  }
}
</script>
